import type { FC, ReactElement } from 'react';

import classNames from 'classnames';
import { motion } from 'framer-motion';
import { observer } from 'mobx-react';

import { animations } from '../../config/animations';
import { useStores } from '../../stores/useStores';

import styles from './Overlay.module.scss';

export interface IOverlayProps {
  className?: string;
  backdropClassName?: string;
  children: ReactElement;
  onClick?: () => void;
  onTransitionEnd?: VoidFunction;
  disableBackdropClick?: boolean;
}

export const Overlay: FC<IOverlayProps> = observer((props) => {
  const { className, backdropClassName, children, onClick, onTransitionEnd, disableBackdropClick } = props;
  const { uiStore } = useStores();

  const handleClose = () => {
    if (disableBackdropClick) {
      return;
    }
    if (onClick) {
      onClick();
    } else {
      uiStore.setCloseDialog();
    }
  };

  return (
    <motion.div
      key="overlay"
      animate={animations.opacity.visible}
      className={classNames(styles.overlay, className)}
      exit={animations.opacity.hidden}
      initial={animations.opacity.hidden}
      onTransitionEnd={onTransitionEnd}
    >
      <div
        className={classNames(styles.overlayBackdrop, backdropClassName, {
          'default-cursor': disableBackdropClick,
        })}
        role="presentation"
        onClick={handleClose}
      />
      {children}
    </motion.div>
  );
});
